import { useRef, useState } from 'react';
import { Dialog } from 'react-aria-components';
import { useTranslation } from 'react-i18next';
import IconButton from '~/components/buttons/NewIconButton';
import SimpleTooltip from '~/components/data-display/SimpleTooltip';
import BookkeepingAccountSelect from '~/components/inputs/Select/BookkeepingAccountSelect';
import Popover from '~/components/popovers/Popover/Popover';
import Text from '~/components/typographies/Text';
import IconBookOpen from '~/icons/icon-book-open.svg?react';
import PlusIcon from '~/icons/icon-plus.svg?react';
import styles from './AdjustmentAccountCell.module.scss';

interface Props {
  disabled?: boolean;
  value: string | null | undefined;
  onChange: (accountId: string | null) => void;
}

const AdjustmentAccountCell: React.FC<Props> = ({ value, disabled, onChange }) => {
  const { t } = useTranslation('bookkeeping', { keyPrefix: 'transactions.create.form' });
  const triggerRef = useRef<HTMLButtonElement>(null);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <SimpleTooltip
        title={disabled ? t('adjustment_account_disabled_tooltip') : ''}
        allowTooltip={disabled}
        mode="span"
        placement="top"
      >
        <IconButton
          ref={triggerRef}
          label={t('adjustment_account_label')}
          Icon={value ? IconBookOpen : PlusIcon}
          variant="ghost"
          onClick={() => setIsOpen(true)}
          disabled={disabled}
        />
      </SimpleTooltip>
      <Popover triggerRef={triggerRef} isOpen={isOpen} onOpenChange={setIsOpen}>
        <Dialog>
          <div className={styles.popoverContent}>
            <Text variant="body2" weight="semibold">
              {t('adjustment_account_label')}
            </Text>
            <BookkeepingAccountSelect
              label={t('adjustment_account_label')}
              hideLabel
              value={value ?? null}
              onChange={(accountId) => {
                onChange(accountId);
                if (accountId !== null) setIsOpen(false);
              }}
            />
          </div>
        </Dialog>
      </Popover>
    </>
  );
};

export default AdjustmentAccountCell;
